<template>
  <v-chip
    v-bind="$attrs"
    :model-value="selected"
    close
    closable
    :color="color"
    :outlined="outlined"
    :style="chipStyle"
    :class="customClass"
    @click:close="$emit('close', item, index)"
  >
    <span class="thin-scroll">{{ displayText }}</span>
    <slot name="append"></slot>
  </v-chip>
</template>

<script>
export default {
  name: "ThinScrollChip",
  inheritAttrs: false,
  props: {
    item: {
      type: [Object, String],
      required: true
    },
    selected: {
      type: Boolean,
      default: true
    },
    itemText: {
      type: String,
      default: "name"
    },
    index: {
      type: Number,
      default: null
    },
    color: {
      type: String,
      default: ""
    },
    outlined: {
      type: Boolean,
      default: false
    },
    chipStyle: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayText() {
      if (typeof this.item === "string") {
        return this.item;
      }
      return this.item[this.itemText] || this.item.id || "";
    }
  }
};
</script>

<style scoped>
.thin-scroll {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  padding-left: 2px;
}

.thin-scroll::-webkit-scrollbar {
  height: 4px;
}

.thin-scroll::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 2px;
}

.thin-scroll::-webkit-scrollbar-track {
  background: transparent;
}
</style>
